<form [formGroup]="form">
  <mat-form-field appearance="outline" class="w-full" aria-label="Search listbox form field">
    <mat-label>{{ 'global.search' | translate }}</mat-label>
    <input
      matInput
      (input)="updateSearchTerm($event)"
      [placeholder]="'global.search' | translate"
      aria-label="Search listbox" />
    <mat-icon aria-label="Search icon" matPrefix>search</mat-icon>
  </mat-form-field>

  <p class="ml-1 mb-2 uppercase text-sm font-thin primary-sublabel">
    {{ label | translate }}
  </p>

  <div *ngIf="filteredList$ | async as filteredList; else loading">
    <ng-container *ngIf="filteredList.length > 0; else empty">
      <mat-selection-list formControlName="items" class="overflow-auto max-h-[20rem]">
        @for (item of filteredList; track item) {
          <mat-list-option
            class="border-b-solid border-b border-b-neutral-90"
            [disabled]="item.disabled"
            [value]="item.id"
            (click)="toggleSelection(item)"
            togglePosition="before"
            aria-label="List option">
            {{ filterKey ? item[filterKey] || item : item }} <span *ngIf="sublabelKey"> ({{ item[sublabelKey] }})</span>
          </mat-list-option>
        }
      </mat-selection-list>
    </ng-container>
  </div>

  <ng-template #loading>
    <div class="flex flex-wrap justify-center w-full">
      <mat-progress-spinner class="h-12 w-12" mode="indeterminate"></mat-progress-spinner>
    </div>
  </ng-template>

  <ng-template #empty>
    <div class="flex flex-wrap justify-center w-full">
      <p>{{ 'global.noItemsFound' | translate }}</p>
    </div>
  </ng-template>
</form>
